import clsx from "clsx";
import { ISelectable } from "./FormElementTypes";
import {
  CheckCircle,
  CheckSquare,
  Circle,
  Square,
} from "@phosphor-icons/react";

export default function Selectable({
  type,
  order,
  isRevealed,
  label,
  isCorrect,
  checked,
  onChange,
  isDisabled = false,
}: ISelectable) {
  const value = String(order + 1); // for simplicity

  const Icon = type === "MULTI" ? Square : Circle;
  const IconChecked = type === "MULTI" ? CheckSquare : CheckCircle;

  return (
    <label
      className={clsx(
        "block select-none flex-1 leading-normal",
        isDisabled ? "" : "animate-fadeIn animate-faster"
      )}
      style={{ animationDelay: isDisabled ? "0s" : `${order * 0.1}s` }}
    >
      <input
        className="inp w-0 h-0 inline float-left opacity-0"
        type={type === "MULTI" ? "checkbox" : "radio"}
        /* {...register("answer")} */
        value={value}
        checked={checked}
        disabled={isDisabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span
        className={clsx(
          "rdCh flex gap-2 p-1.5 pr-2.5 transition-all rounded-lg border border-white/20 items-start",
          !isDisabled &&
          "hover:bg-white/10 cursor-pointer",
          isCorrect && isRevealed ? "bg-myGreen/50" : null
        )}
      >
        {checked ? (
          <IconChecked
            size={18}
            color="white"
            className="icon-checked shrink-0 mt-0.75 w-auto"
          />
        ) : (
          <Icon
            size={18}
            color="white"
            className="icon shrink-0 mt-0.75 w-auto"
          />
        )}
        <span className="label" dangerouslySetInnerHTML={{ __html: label }} />
      </span>
    </label>
  );
}
